<div class="input-group" data-cy="divProfileSelectorContainer">
  <p-autoComplete
    [(ngModel)]="displayName"
    [inputStyleClass]="class"
    [placeholder]="placeholder"
    minLength="3"
    [suggestions]="profiles"
    [virtualScroll]="true"
    [virtualScrollItemSize]="itemSize"
    [lazy]="true"
    (onLazyLoad)="onLazyLoad($event)"
    (completeMethod)="loadProfiles($event)"
    (onSelect)="dropdownProfileSelected($event)"
    [appendTo]="'body'"
  >
    <ng-template let-profile pTemplate>
      <div class="table table-striped profile-selector-result" data-cy="divProfileSelectorResult">
        <div class="container-fluid">
          <div class="row">
            <div class="col-sm-1">
              <wl-profile-type-icon
                [isMember]="profile.Member"
                [isOrg]="profile.OrgInd"
                [profileId]="profile.ProfileId"
                [memberTypeIconColor]="profile.MemberTypeIconColor"
              ></wl-profile-type-icon>
            </div>
            <div class="col-sm-11">
              <div>
                <b data-cy="divProfileSelectorReportNameId"> {{ profile.ReportName }} ({{ profile.ProfileId }}) </b>
              </div>
              <div>
                <span [hidden]="profile.Address1 == ''"> {{ profile.Address1 }} </span>
                <span [hidden]="profile.Address2 == ''"> {{ profile.Address2 }} </span>
                <span [hidden]="profile.City == ''"> {{ profile.City }} </span>
                <span [hidden]="profile.State == '' && profile.Zip == ''"> , </span>
                <span [hidden]="profile.State == ''"> {{ profile.State }} </span>
                <span [hidden]="profile.Zip == ''"> {{ profile.Zip }} </span>
              </div>
            </div>
          </div>
        </div>
      </div>
    </ng-template>
    <!-- outside the fixed-height virtual-scroll rows so the indicator isn't clipped -->
    <ng-template #footer>
      <div [hidden]="!isSearching || !hasMoreSearchResults()">
        <wl-busy [show]="isSearching"></wl-busy>
      </div>
    </ng-template>
  </p-autoComplete>

  <span class="input-group-btn">
    <button pButton type="button" class="btn btn-default" icon="pi pi-times-circle" (click)="setNone()"></button>
    <wl-busy [show]="isSearching"></wl-busy>
  </span>
</div>
